import { EnvironmentProviders, ErrorHandler, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ChunkLoadErrorHandler } from './chunk-load-error.handler';
import { ReleaseCheckService } from './release-check.service';

/**
 * Moves a tab running an older release onto the deployed one: on a failed navigation or code
 * file, and at the next navigation once the release check has seen a new release. For each app's
 * root providers.
 */
export function provideReleaseRefresh(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    provideAppInitializer(() => inject(ReleaseCheckService).start()),
  ]);
}
